//export const API_URL = "http://localhost:8000";
//export const WEBSITE_URL = "https://gemengen.zesummeliewen.lu/";
//helper for localhost detection:
let url = window.location.href;
let localhost = false;
if (url.includes('localhost')) {
    localhost = true;
}
export const PRODUCTION = !localhost;
export const ASSET_URL = PRODUCTION ? 'https://gemengen.zesummeliewen.lu/wp-content/themes/salient-child/includes/mfi/pact-form' : '';
// export const ASSET_URL = PRODUCTION ? 'https://mfi.cuco.dev/wp-content/themes/salient-child/includes/mfi/pact-form' : '';
